import {
  Button,
  Grid,
  MenuItem,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import CustomTextFieldComp from "../../../newTestPrep/newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../../newTestPrep/newComponent/AutocompleteComp";
import { useNavigate } from "react-router-dom";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function AddMoreServiceForm({ studentInfo, showSnackbar }) {
  console.log("studentInfo", studentInfo);
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    border: `2px solid #2196F3`,
    borderRadius: "10px",
  }));

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    setError,
    clearErrors,
    trigger,
    getValues,
  } = useForm();
  const navigate = useNavigate();
  const [serviceList, setServiceList] = useState([]);
  const [service, setService] = useState(null);
  const userId = localStorage.getItem("userId");
  const [subserViceList, setSubServiceList] = useState([]);
  const [subService, setSubservice] = useState(null);
  const [premiumProgramList, setPremiumProgramList] = useState([]);
  const [premiumProgram, setPremiumProgram] = useState(null);
  const [assignToList, setAssignToList] = useState([]);
  const [assignTo, setAssignTo] = useState(null);
  const [prospectiveLevalList, setprospectiveLevalList] = useState([]);
  const [prospectiveLevel, setProspectiveLevel] = useState(null);
  const [taskList, setTaskList] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [testPurposeList, setTestPurposeList] = useState([]);
  const [testPurpose, setTestPurpose] = useState(null);
  const [experienceList, setExperienceList] = useState([]);
  const [testTypeList, setTestTypeList] = useState([]);
  const [targetCountryList, setTargetCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [leadSorceTypeList, setLeadSorceTypeList] = useState([]);
  const [selectedLeadSorce, setSelectedLeadSorce] = useState(null);
  const [subLeadSorceTypelist, setSubLeadSorceTypeList] = useState([]);
  const [selectedSubLeadSorce, setSelectedSubLeadSource] = useState(null);
  const [examList, setExamList] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null);
  const [testBooking, setTestBooking] = useState(null);
  const [proficiencyList, setProficiencyList] = useState([]);
  const [interestLevalList, setInterestLevalList] = useState([]);
  const [followUpReasons, setFollowUpReasons] = useState([]);
   const [followupReasonname, setFollowupReasonName] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const filteredData = sortedData.filter(
            (i) => i.service_name !== "Undefined"
          );
          setServiceList(filteredData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleServiceChange = (event, value) => {
    setSubservice(null);
    setPremiumProgram(null);
    setService(value);

    setValue("service_id", value?.id);
    setValue("sub_service_id", null);
    setValue("premium_admission_programs_id", null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();
          const subServiceData = data.filter(
            (i) => i.service_id === service?.id
          );
          const sortedData = subServiceData.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setSubServiceList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [service]);

  const handleSubServiceChange = (e, value) => {
    setSubservice(value);
    setPremiumProgram(null);
    setValue("sub_service_id", value?.id);
    setValue("premium_admission_programs_id", null);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}subservice-program`)
      .then((response) => response.json())
      .then((data) => {
        const subserviceData = data.filter(
          (i) => subService?.id === i?.sub_service_id
        );
        setPremiumProgramList(subserviceData);
      })
      .catch((error) => {
        console.error("Error fetching sub service programs:", error);
      });
  }, [subService]);

  const handleProgramChange = (e, value) => {
    setValue("premium_admission_programs_id", value?.id);
    setPremiumProgram(value);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}prospectivelevel`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const filteredData = data.find(
            (i) => i.prospective_level === "New lead"
          );
          setProspectiveLevel(filteredData);
          setValue("prospective_level_id", filteredData?.id);
          setprospectiveLevalList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleProspectiveChange = (e, value) => {
    setProspectiveLevel(value);
    setValue("prospective_level_id", value?.id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getadvisors/${userId}`
        );
        if (response.ok) {
          const data = await response.json();

          setAssignToList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleAssignToChange = (e, value) => {
    setAssignTo(value);
    setValue("assign_to", value?.user_id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}leadsource`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const selecteditem = sortedData.find(
            (i) => i.id === studentInfo?.lead_source_type_id?.id
          );
          setSelectedLeadSorce(selecteditem || null);
          setValue("lead_source_type_id", selecteditem?.id || null);
          setLeadSorceTypeList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleLeadSorceChange = (event, value) => {
    setSelectedLeadSorce(value);
    setValue("lead_source_type_id", value?.id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subleadsource`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const filterdSubleadSource = sortedData.filter(
            (i) => i.lead_source_type_id === selectedLeadSorce?.id
          );
          const selectedItem = filterdSubleadSource.find(
            (i) => i.id === studentInfo?.sub_lead_source_type_id?.id
          );
          setSelectedSubLeadSource(selectedItem);
          setValue("sub_lead_source_type_id", selectedItem?.id);
          setSubLeadSorceTypeList(filterdSubleadSource);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedLeadSorce]);

  const handleSubLeadSorceChange = (event, value) => {
    setSelectedSubLeadSource(value);
    setValue("sub_lead_source_type_id", value?.id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}typeoftask`);
        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setTaskList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);



   useEffect(() => {
      fetch(`${API_ENDPOINT}taskfollowupreason`)
        .then((response) => response.json())
        .then((data) => {
          setFollowUpReasons(data);
        })
        .catch((error) => {
          console.error('Error fetching follow up reasons:', error);
        });
    }, []);
  
    const handletaskChange = (event, value) => {
  setSelectedTask(value);
  setValue("type_of_task", value?.id || null);

  // Reset follow up reason whenever task changes
  setFollowupReasonName(null);
  setValue("follow_up_reason_id", null);
};


    const handleFollowupReasonChange = (event, value) => {
      setFollowupReasonName(value);
      setValue('follow_up_reason_id', value?.id ?? null)
    };
   
  


  const handleExamStatusChange = (e, value) => {
    setValue("exam_status_id", value?.id);
    setSelectedExam(value);
  };

  const handleProficiencyChange = (e, value) => {
    setValue("assumptive_proficiency_level_id", value?.id);
  };

  const handleTestBook = (e) => {
    setTestBooking(e.target.value);
    setValue("test_taken", e.target.value);
  };

  const onSubmit = async (data) => {
    console.log("datais", data);
    try {
      const requestData = {
        ...data,
        user_id: parseInt(userId),
        enquiry_id: studentInfo?.id,
        enq_personal_detail_id: studentInfo?.enq_personal_detail_id,
      };
      const response = await fetch(
        `${API_ENDPOINT}advisordashboard/add-subservice`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );
      if (response.ok) {
        showSnackbar("Sub Service  Added Successfully", "success");

        setTimeout(() => {
          navigate(`/enquiry-summary/${studentInfo?.enq_personal_detail_id}`);
        }, 1500);
      } else if (response.status === 409) {
        showSnackbar("This sub-service already exists.", "error");
      } else if (response.status === 405) {
        showSnackbar("Mobile number is undefined", "error");
      } else {
        showSnackbar("Failed to add Sub Service ", "error");
        throw new Error("Failed to add  employee status");
      }
    } catch (error) {
      showSnackbar("Failed to add Sub Service ", "error");
    }
  };

  console.log(
    "studentinfois",
    studentInfo.sub_lead_source_type_id?.id === null ||
      studentInfo.sub_lead_source_type_id === null
      ? false
      : true
  );
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Item>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h4"> Mandatory Information</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="h6">
                  Service Name
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Controller
                  name="service_id"
                  control={control}
                  rules={{ required: "Service name is required" }}
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      select
                      {...field}
                      InputProps={{
                        style: { borderRadius: "10px" },
                      }}
                      fullWidth
                      value={service}
                      onChange={handleServiceChange}
                      error={!!errors.service_id}
                      helperText={errors.service_id?.message}
                      options={serviceList}
                      getOptionLabel={(option) => option.service_name}
                    />
                  )}
                />
              </Grid>
              {service !== null && (
                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <Typography variant="h6">
                    Sub Service
                    <span
                      style={{
                        color: "red",
                        position: "absolute",
                        marginLeft: "4px",
                        fontSize: "1em",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Controller
                    name="sub_service_id"
                    control={control}
                    rules={{ required: "Sub Service is required" }}
                    render={({ field }) => (
                      <CustomAutocompleteComp
                        {...field}
                        value={subService}
                        onChange={handleSubServiceChange}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                        fullWidth
                        error={!!errors.sub_service_id}
                        helperText={errors.sub_service_id?.message}
                        options={subserViceList}
                        getOptionLabel={(option) => option.name}
                      />
                    )}
                  />
                </Grid>
              )}

              {(subService?.id === 13 || subService?.id === 14) && (
                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <Typography variant="h6">
                    {subService?.id === 14
                      ? " Postgraduate Admission Program"
                      : subService?.id === 13
                      ? "Undergraduate Admission Program"
                      : ""}
                    <span
                      style={{
                        color: "red",
                        position: "absolute",
                        marginLeft: "4px",
                        fontSize: "1em",
                      }}
                    >
                      *
                    </span>
                  </Typography>
                  <Controller
                    name="premium_admission_programs_id"
                    control={control}
                    // rules={{ required:subService?.id === 13 ||  subService?.id === 14 }}
                    render={({ field }) => (
                      <CustomAutocompleteComp
                        {...field}
                        value={premiumProgram}
                        onChange={handleProgramChange}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                        fullWidth
                        options={premiumProgramList}
                        getOptionLabel={(option) => option.name}
                      />
                    )}
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="h6">
                  Prospective Level{" "}
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Controller
                  name="prospective_level_id"
                  control={control}
                  rules={{ required: "Prospective level is required" }}
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      value={prospectiveLevel}
                      onChange={handleProspectiveChange}
                      InputProps={{
                        style: { borderRadius: "10px" },
                      }}
                      fullWidth
                      error={!!errors.prospective_level_id}
                      helperText={errors.prospective_level_id?.message}
                      options={prospectiveLevalList}
                      getOptionLabel={(option) => option.prospective_level}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="h6">
                  Assign To{" "}
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Controller
                  name="assign_to"
                  control={control}
                  rules={{ required: "Asign to is required" }}
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      value={assignTo}
                      onChange={handleAssignToChange}
                      InputProps={{
                        style: { borderRadius: "10px" },
                      }}
                      fullWidth
                      error={!!errors.assign_to}
                      helperText={errors.assign_to?.message}
                      options={assignToList}
                      getOptionLabel={(option) => `${
                                      option.first_name ? option.first_name : ""
                                    } ${
                                      option.last_name ? option.last_name : ""
                                    }`}
                    /> 
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="h6">
                  Lead Source
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Controller
                  name="lead_source_type_id"
                  control={control}
                  rules={{ required: "This  is required field" }}
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      value={selectedLeadSorce}
                      onChange={handleLeadSorceChange}
                      readOnly={
                        studentInfo?.lead_source_type_id?.id === null ||
                        studentInfo?.lead_source_type_id === null
                          ? false
                          : true
                      }
                      fullWidth
                      error={!!errors.lead_source_type_id}
                      helperText={errors.lead_source_type_id?.message}
                      options={leadSorceTypeList}
                      getOptionLabel={(option) => option.name}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="h6">
                  Sub Lead Source
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Controller
                  name="sub_lead_source_type_id"
                  control={control}
                  rules={{ required: "This  is required field" }}
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      value={selectedSubLeadSorce}
                      onChange={handleSubLeadSorceChange}
                      readOnly={
                        studentInfo.sub_lead_source_type_id?.id === null ||
                        studentInfo.sub_lead_source_type_id === null
                          ? false
                          : true
                      }
                      fullWidth
                      error={!!errors.sub_lead_source_type_id}
                      helperText={errors.sub_lead_source_type_id?.message}
                      options={subLeadSorceTypelist}
                      getOptionLabel={(option) => option.source_type}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid item xs={12}>
          <Item>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h4">Add Task</Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="h6">
                  Type Of Task{" "}
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Controller
                  name="type_of_task"
                  control={control}
                  rules={{ required: "Type of task is required" }}
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      value={selectedTask}
                      onChange={handletaskChange}
                      InputProps={{
                        style: { borderRadius: "10px" },
                      }}
                      fullWidth
                      error={!!errors.type_of_task}
                      helperText={errors.type_of_task?.message}
                      options={taskList}
                      getOptionLabel={(option) => option.name_of_task_type}
                    />
                  )}
                />
              </Grid>
              {selectedTask?.id === 2 && (
  <Grid item xs={12} sm={6} md={4} lg={4}>
    <Typography variant="h6">
      Follow Up Reason
      <span
        style={{
          color: "red",
          position: "absolute",
          marginLeft: "4px",
          fontSize: "1em",
        }}
      >
        *
      </span>
    </Typography>

   <Controller
  name="follow_up_reason_id"
  control={control}
  render={({ field }) => (
    <CustomAutocompleteComp
      options={followUpReasons}
      value={followupReasonname}
      getOptionLabel={(option) => option.follow_up_reason}
      onChange={(e, value) => {
        setFollowupReasonName(value);
        field.onChange(value?.id ?? null);
      }}
      error={!!errors.follow_up_reason_id}
      helperText={errors.follow_up_reason_id?.message}
    />
  )}
/>
  </Grid>
)}

              <Grid item xs={6} md={4} lg={4}>
                <Typography variant="h6">
                  Due Date
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Controller
                  name="task_due_date"
                  control={control}
                  rules={{ required: "Due date is required" }}
                  render={({ field }) => (
                    <CustomTextFieldComp
                      size="normal"
                      type="date"
                      {...field}
                      InputProps={{
                        style: { borderRadius: "10px" },
                        inputProps: {
                          min: new Date().toISOString().split("T")[0],
                        },
                      }}
                      fullWidth
                      error={!!errors.task_due_date}
                      helperText={errors.task_due_date?.message}
                    ></CustomTextFieldComp>
                  )}
                />
              </Grid>

              <Grid item xs={6} md={4} lg={4}>
                <Typography variant="h6">
                  Due Time
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Controller
                  name="task_due_time"
                  control={control}
                  rules={{ required: "Due Time is required" }}
                  render={({ field }) => (
                    <CustomTextFieldComp
                      size="normal"
                      type="time"
                      {...field}
                      InputProps={{
                        style: { borderRadius: "10px" },
                      }}
                      fullWidth
                      error={!!errors.task_due_time}
                      helperText={errors.task_due_time?.message}
                    ></CustomTextFieldComp>
                  )}
                />
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid item xs={12}>
          <Item>
            <Typography variant="h4">Add Notes</Typography>
            <Typography variant="h6" textAlign="left">
              Note(Optional)
            </Typography>
            <Controller
              name="notes"
              control={control}
              // rules={{ required: "Note is required" }}
              render={({ field }) => (
                <TextField
                  size="small"
                  {...field}
                  multiline
                  rows={5}
                  fullWidth
                  InputProps={{
                    style: { borderRadius: "12px" },
                  }}
                />
              )}
            />
          </Item>
        </Grid>

        <Grid item xs={12} textAlign="end">
          <Button
            size="small"
            color="secondary"
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </Button>
        </Grid>
    
      </Grid>
    </>
  );
}
